
export const semanticColors_light = {
  yellow: {
    50: "#FFFDEB",
    100: "#FFF9C2",
    200: "#FFF38A",
    300: "#FFED4D",
    400: "#FFE426",
    500: "#FFD900",
    base: "#FFD900",
    600: "#E6C200",
    700: "#B89A00",
    800: "#806C00",
    900: "#4D3F00",
  },
  blue: {
    50: "#EFF6FF",
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#3B82F6",
    base: "#3B82F6",
    600: "#2563EB",
    700: "#1D4ED8",
    800: "#1E40AF",
    900: "#1E3A8A",
  },
  success: {
    50: "#ECFDF5",
    100: "#D1FAE5",
    200: "#A7F3D0",
    300: "#6EE7B7",
    400: "#34D399",
    500: "#10B981",
    base: "#10B981",
    600: "#059669",
    700: "#047857",
    800: "#065F46",
    900: "#064E3B",
  },
  warning: {
    50: "#FFF7ED",
    100: "#FFEDD5",
    200: "#FED7AA",
    300: "#FDBA74",
    400: "#FB923C",
    500: "#F97316",
    base: "#F97316",
    600: "#EA580C",
    700: "#C2410C",
    800: "#9A3412",
    900: "#7C2D12",
  },
  danger: {
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F87171",
    500: "#EF4444",
    base: "#EF4444",
    600: "#DC2626",
    700: "#B91C1C",
    800: "#991B1B",
    900: "#7F1D1D",
    1000: "#F44336",
  },
  info: {
    50: "#EFF6FF",
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#3B82F6",
    base: "#3B82F6",
    600: "#2563EB",
    700: "#1D4ED8",
    800: "#1E40AF",
    900: "#1E3A8A",
  },
};

export const semanticColors_dark = {
  yellow: {
    50: "#2A2508",
    100: "#3A320A",
    200: "#544710",
    300: "#786618",
    400: "#FFE426",
    500: "#FFD900",
    base: "#FFD900",
    600: "#FFE44D",
    700: "#FFEE85",
    800: "#FFF5B8",
    900: "#FFFAE0",
  },
  blue: {
    50: "#10203A",
    100: "#152B4D",
    200: "#1E3D69",
    300: "#2C5490",
    400: "#60A5FA",
    500: "#3B82F6",
    base: "#3B82F6",
    600: "#5B9BF8",
    700: "#8FBBFB",
    800: "#BBD5FD",
    900: "#DDEAFE",
  },
  success: {
    50: "#0B2A20",
    100: "#0F3A2B",
    200: "#155040",
    300: "#1C6B54",
    400: "#34D399",
    500: "#10B981",
    base: "#10B981",
    600: "#34D399",
    700: "#6EE7B7",
    800: "#A7F3D0",
    900: "#D1FAE5",
  },
  warning: {
    50: "#2B1A0C",
    100: "#3B2310",
    200: "#553217",
    300: "#77461F",
    400: "#FB923C",
    500: "#F97316",
    base: "#F97316",
    600: "#FB923C",
    700: "#FDBA74",
    800: "#FED7AA",
    900: "#FFEDD5",
  },
  danger: {
    50: "#2E1516",
    100: "#3F1B1D",
    200: "#5A2426",
    300: "#7D3033",
    400: "#F87171",
    500: "#EF4444",
    base: "#EF4444",
    600: "#F87171",
    700: "#FCA5A5",
    800: "#FECACA",
    900: "#FEE2E2",
    1000: "#F87171",
  },
  info: {
    50: "#10203A",
    100: "#152B4D",
    200: "#1E3D69",
    300: "#2C5490",
    400: "#60A5FA",
    500: "#3B82F6",
    base: "#3B82F6",
    600: "#5B9BF8",
    700: "#8FBBFB",
    800: "#BBD5FD",
    900: "#DDEAFE",
  },
};

export const roleColors_light = {
    residential: {
      50: "#E8F5E8",
      100: "#C8E6C9",
      200: "#A5D6A7",
      300: "#81C784",
      400: "#66BB6A",
      500: "#4CAF50",
      600: "#43A047",
      base: "#43A047",
      700: "#2E7D32",
      800: "#1B5E20",
      900: "#0D3C11",
    },
    residentialNew: {
      50: "#FFF8F0",
      100: "#FEECD8",
      200: "#FDD5AB",
      300: "#FBB876",
      400: "#F99543",
      500: "#F7751A",
      600: "#E85C0D",
      base: "#F7751A",
      700: "#C04610",
      800: "#983814",
      900: "#7A2E13",
    },
    commercial: {
      50: "#E3F2FD",
      100: "#BBDEFB",
      200: "#90CAF9",
      300: "#64B5F6",
      400: "#42A5F5",
      500: "#2196F3",
      600: "#1E88E5",
      base: "#1E88E5",
      700: "#0277BD",
      800: "#01579B",
      900: "#003C6C",
    },
  };

export const statusColors_light = {
    forRevision: "#475569",
    approved: "#B86E00",
    scheduled: "#4474CF",
    inProgress: "#D97706",
    completed: "#15803D",
    cancelled: "#DC2626",
    visitJob: "#AF40F7",
    visitQuote: "#FBB876",
    active: "#15803D",
    failed: "#DC2626",
    suspended: "#D97706",
    approvalPending: "#B86E00",
    cancelledStrong: "#991B1B",
  };

export const roleColors_dark = {
    residential: {
      50: "#0F2A14",
      100: "#153A1C",
      200: "#1D5027",
      300: "#276B34",
      400: "#66BB6A",
      500: "#4CAF50",
      600: "#5FC163",
      base: "#5FC163",
      700: "#81C784",
      800: "#A5D6A7",
      900: "#C8E6C9",
    },
    residentialNew: {
      50: "#2C1A0B",
      100: "#3C230E",
      200: "#553114",
      300: "#77451B",
      400: "#F99543",
      500: "#F7751A",
      600: "#F98B3C",
      base: "#F7751A",
      700: "#FBB876",
      800: "#FDD5AB",
      900: "#FEECD8",
    },
    commercial: {
      50: "#0E2438",
      100: "#13314C",
      200: "#1A4468",
      300: "#245C8F",
      400: "#42A5F5",
      500: "#2196F3",
      600: "#42A5F5",
      base: "#42A5F5",
      700: "#64B5F6",
      800: "#90CAF9",
      900: "#BBDEFB",
    },
  };

export const statusColors_dark = {
    forRevision: "#94A3B8",
    approved: "#E9A23B",
    scheduled: "#7FA8F0",
    inProgress: "#F0A73C",
    completed: "#4ADE80",
    cancelled: "#F87171",
    visitJob: "#C77BFA",
    visitQuote: "#FBB876",
    active: "#4ADE80",
    failed: "#F87171",
    suspended: "#F0A73C",
    approvalPending: "#E9A23B",
    cancelledStrong: "#FCA5A5",
  };
